import { ChangeDetectionStrategy, Component, effect, inject, OnInit, untracked } from '@angular/core';
import { AppLayout, LayoutService } from '@dgacontrol-frontend/sakai-ng';
import { QuoteRequestStatusStore } from '@dgacontrol-frontend/billing-data-access';

import { quoteRequestsLabel, withQuoteRequestsLabel } from './quote-requests-menu';

/**
 * Authenticated shell of admin, like `web-shell`: Sakai's frame plus what must outlive
 * any screen. Today, the count of unattended landing requests in the menu (M-bill-19):
 * the store lives on this route, so `AppComponent` (root injector) cannot read it.
 */
@Component({
  selector: 'app-admin-shell',
  standalone: true,
  imports: [AppLayout],
  templateUrl: './admin-shell.component.html',
  styleUrl: './admin-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminShellComponent implements OnInit {
  private readonly layout = inject(LayoutService);
  private readonly quoteRequestStatus = inject(QuoteRequestStatusStore);

  constructor() {
    effect(() => {
      const label = quoteRequestsLabel(this.quoteRequestStatus.unattended());
      untracked(() => {
        this.layout.menuItems.update((menu) => withQuoteRequestsLabel(menu, label));
      });
    });
  }

  /** Once per authenticated entry (login, hard refresh); the screens that attend or free a
   *  request read it again. A failed read is the interceptor's toast. */
  ngOnInit(): void {
    this.quoteRequestStatus.fetchStatus().subscribe({ error: () => undefined });
  }
}
